import { render, staticRenderFns } from "./PricingSection.vue?vue&type=template&id=2e00e922&scoped=true"
import script from "./PricingSection.vue?vue&type=script&lang=js"
export * from "./PricingSection.vue?vue&type=script&lang=js"
import style0 from "./PricingSection.vue?vue&type=style&index=0&id=2e00e922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e00e922",
  null
  
)

export default component.exports